import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {
  AlarmIconWrapper,
  ExitPopupHeaderContentWrapper,
  HeaderElement
} from './styles'

interface Props {
  variant: 'searchResultsPage' | 'accommodationPage' | 'loading' | 'dealFreeze'
  isMobile?: boolean
}

export const ExitPopupHeader = ({variant, isMobile}: Props) => {
  switch (variant) {
    case 'loading':
      return (
        <Text
          variant={isMobile ? 'titleM' : 'titleL'}
          colorPath="content.neutral.inverse"
        >
          <FormattedMessageWrapper
            dataId="searchingTravelSites"
            id="searchingTravelSites"
            defaultMessage="Searching all the best travel sites"
          />
        </Text>
      )
    case 'dealFreeze':
      return (
        <HeaderElement>
          <ExitPopupHeaderContentWrapper>
            <AlarmIconWrapper>
              <Icon name="Ice" size="md" />
            </AlarmIconWrapper>
            <Text variant="titleL">
              <FormattedMessageWrapper
                id="dealFreeze.exitPopupTitle"
                defaultMessage="Freeze this deal. Decide later."
              />
            </Text>
          </ExitPopupHeaderContentWrapper>
        </HeaderElement>
      )
    case 'searchResultsPage':
      return (
        <HeaderElement>
          <ExitPopupHeaderContentWrapper>
            <AlarmIconWrapper>
              <Icon name="Bell" size="md" />
            </AlarmIconWrapper>
            <Text variant={isMobile ? 'titleM' : 'titleL'}>
              <FormattedMessageWrapper
                id="bestDealModal.worthALook"
                defaultMessage="Worth a look before you go"
              />
            </Text>
          </ExitPopupHeaderContentWrapper>
        </HeaderElement>
      )
    case 'accommodationPage':
      return (
        <HeaderElement>
          <ExitPopupHeaderContentWrapper>
            <AlarmIconWrapper>
              <Icon name="Bell" size="md" />
            </AlarmIconWrapper>
            <Text variant="titleM">
              <FormattedMessageWrapper
                id="bestDealModal.dealsOnOtherSites"
                defaultMessage="Check out these similar deals on other sites"
              />
            </Text>
          </ExitPopupHeaderContentWrapper>
        </HeaderElement>
      )
    default:
      return null
  }
}
